<template>
  <div class="login-container">
    <div class="login-bg"></div>
    <div class="login-content">
      <div class="login-form-card">
        <div class="login-header">
          <div class="logo">
            <img :src="logo" alt="智慧后勤管理系统" />
          </div>
          <h2>智慧后勤管理系统</h2>
          <p class="login-desc">专业的后勤服务管理平台</p>
        </div>
        <el-form
          :model="form"
          ref="loginForm"
          label-position="top"
          class="login-form"
        >
          <el-form-item prop="username">
            <el-input
              v-model="form.username"
              placeholder="请输入账号"
              prefix-icon="User"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="form.password"
              type="password"
              placeholder="请输入密码"
              prefix-icon="Lock"
              autocomplete="off"
              @keyup.enter="submitForm()"
            />
          </el-form-item>
          <el-form-item>
            <SliderVerify ref="sliderVerify" @success="onSliderSuccess" />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="login-btn"
              :disabled="!sliderVerified"
              @click="submitForm()"
            >
              登录
            </el-button>
          </el-form-item>
          <div class="login-footer">
            <span class="copyright">© 2026 智慧后勤管理系统</span>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import { httpService } from "@/utils/httpService";
import { User, Lock } from "@element-plus/icons-vue";
import SliderVerify from "@/components/SliderVerify.vue";

export default {
  name: "login",
  components: { User, Lock, SliderVerify },
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      logo: require("../assets/images/logo.png"),
      sliderVerified: false,
      submitting: false,
    };
  },
  methods: {
    onSliderSuccess() {
      this.sliderVerified = true;
    },
    resetSlider() {
      this.sliderVerified = false;
      if (this.$refs.sliderVerify) {
        this.$refs.sliderVerify.reset();
      }
    },
    submitForm() {
      if (this.submitting) return;
      if (!this.form.username || !this.form.password) {
        ElMessage.warning("请输入账号和密码");
        return;
      }
      if (!this.sliderVerified) {
        ElMessage.warning("请先完成滑块验证");
        return;
      }
      this.submitting = true;
      httpService(
        "/api/login",
        "username=" + this.form.username + "&password=" + this.form.password,
        "post"
      ).then((data) => {
        this.submitting = false;
        if (data.code == 200) {
          sessionStorage.setItem("user", JSON.stringify(data.obj.user));
          sessionStorage.setItem("token", data.obj.token);
          this.$router.push({ path: "/indexView" });
        } else {
          ElMessage.error(data.msg);
          // 登录失败后重置滑块，需重新验证
          this.resetSlider();
        }
      }).catch(() => {
        this.submitting = false;
        this.resetSlider();
      });
    },
    resetForm() {
      this.$refs.loginForm.resetFields();
    },
  },
};
</script>

<style scoped>
.login-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.login-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #ffffff;
}

.login-content {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-form-card {
  width: 420px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  padding: 40px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.login-form-card:hover {
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.logo {
  margin-bottom: 20px;
}

.logo img {
  width: 80px;
  height: 80px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.login-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 8px 0;
}

.login-desc {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.login-form {
  width: 100%;
}

.login-form .el-form-item {
  margin-bottom: 20px;
}

.login-form .el-input {
  height: 48px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.login-form .el-input__wrapper {
  border-radius: 8px;
  box-shadow: 0 0 0 1px #e5e7eb inset;
  transition: all 0.3s ease;
}

.login-form .el-input__wrapper:hover {
  box-shadow: 0 0 0 1px #3070f0 inset;
}

.login-form .el-input__wrapper.is-focus {
  box-shadow: 0 0 0 1px #3070f0 inset, 0 0 0 3px rgba(48, 112, 240, 0.1);
}

.login-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  background: linear-gradient(135deg, #3070f0 0%, #1a60eb 100%);
  border: none;
  transition: all 0.3s ease;
}

.login-btn:hover {
  background: linear-gradient(135deg, #1a60eb 0%, #1757d6 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(48, 112, 240, 0.3);
}

.login-btn:active {
  transform: translateY(0);
}

.login-btn.is-disabled,
.login-btn.is-disabled:hover {
  background: #a0c4fd;
  border: none;
  transform: none;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 0.7;
}

.login-footer {
  margin-top: 30px;
  text-align: center;
}

.copyright {
  font-size: 12px;
  color: #999;
}

@media (max-width: 768px) {
  .login-form-card {
    width: 90%;
    max-width: 400px;
    padding: 30px;
  }
}
</style>
